import React from 'react';
import { motion } from 'framer-motion';
import { CreditCardIcon, FileTextIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
const HERO_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/61b20d61-9509-40a7-9daf-ead51198cf5e.jpg';
const trustBadges = [{
  icon: FileTextIcon,
  label: '100% Digital'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 min'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}];
export function Hero() {
  return <section className="w-full bg-base" data-id="element-119" data-mp="sbb2hg66ocdb">
      <div className="mx-auto max-w-4xl px-5 pt-8 pb-12 text-center md:pt-16 md:pb-20" data-id="element-120" data-mp="sa9r1al99nv2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-121" data-mp="nczt16jsw3vm">
          <span className="inline-flex items-center rounded-full bg-blue-dark px-4 py-1.5 text-[11px] font-medium uppercase tracking-badge text-white sm:text-xs" data-id="element-122" data-mp="384js0vnybdrc">
            🇦🇷 RG 5866/2026 · ARCA · Vigente desde el 1° de julio de 2026
          </span>
          <h1 className="mx-auto mt-5 max-w-3xl text-3xl font-black leading-[1.15] text-ink sm:text-4xl md:text-5xl" data-id="element-123" data-mp="39b4knaxh4c7o">
            ¿Estudiaste 4 años para{' '}
            <span className="text-accent" data-id="element-124" data-mp="30i18d5yke5em">perder horas en ARCA?</span>
          </h1>
          <p className="mx-auto mt-5 max-w-3xl text-base leading-relaxed text-ink-soft sm:text-lg" data-id="element-125" data-mp="30fya5yn9d5yt">
            La RG 5866 es una trampa operativa para los estudios.{' '}
            <span className="font-bold text-accent" data-id="element-126" data-mp="2ql6e4z9bqr65">
              Con EstudioPack estructurás la implementación técnica en 10
              minutos y recuperás la libertad de tu tiempo.
            </span>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 18,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} transition={{
        duration: 0.55,
        delay: 0.12
      }} className="mx-auto mt-7 max-w-3xl" data-id="element-127" data-mp="2hljas7x1bbag">
          <img src={HERO_IMG} alt="Herramientas organizadas para el Encuadre y la Notificación de sujetos obligados por la RG 5866" className="w-full rounded-2xl border border-alt shadow-xl" data-id="element-128" data-mp="icrn2n3lyf7n" />
          <p className="mt-3 text-sm font-medium text-ink-soft" data-id="element-129" data-mp="161t0korasgjs">
            El estándar de implementación usado por contadores independientes y
            estudios contables.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        delay: 0.24
      }} data-id="element-130" data-mp="x1ec5gj1elc2">
          <div className="mt-7 flex flex-wrap justify-center gap-x-5 gap-y-2" data-id="element-131" data-mp="3htpyjt6msmmz">
            {trustBadges.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 text-sm font-medium text-ink" data-id="element-132" data-mp="21a4tjve00i5z">
                <Icon className="h-4 w-4 text-blue" strokeWidth={2.2} data-id="element-133" data-mp="26869i7g4o1d8" />
                {label}
              </span>)}
          </div>

          <a href="#precio" className="mt-6 inline-flex w-full items-center justify-center rounded-xl bg-accent px-6 py-4 text-base font-bold text-white shadow-lg shadow-accent/20 transition-all hover:bg-accent-dark active:scale-[0.98] sm:w-auto sm:text-lg" data-id="element-134" data-mp="2g0luzeqmv82v">
            → QUIERO SABER MÁS 
          </a>
          <p className="mt-3 flex justify-center gap-1.5 text-sm text-ink-soft" data-id="element-135" data-mp="2tysflt6knbkl">
            <LockIcon className="mt-0.5 h-3.5 w-3.5 shrink-0" data-id="element-136" data-mp="uo0shxp2cmo0" />
            Pago seguro · Descarga inmediata · Garantía 7 días sin preguntas
          </p>
          <div className="mx-auto mt-6 grid max-w-3xl grid-cols-2 gap-x-4 gap-y-6 rounded-2xl bg-blue-dark px-5 py-6 text-center sm:grid-cols-4 sm:px-8" data-id="element-137" data-mp="4b47lugz66jz">
            <div data-id="element-138" data-mp="3vhfdq50udxi6">
              <p className="text-2xl font-black leading-none text-white sm:text-3xl" data-id="element-139" data-mp="3vk1ixy09g0x8">
                +500
              </p>
              <p className="mt-2 text-xs font-bold text-greenlive sm:text-sm" data-id="element-140" data-mp="9aqme8cgbuuw">
                contadores confían
              </p>
            </div>
            <div data-id="element-141" data-mp="3hqsgyien6hoq">
              <p className="text-2xl font-black leading-none text-white sm:text-3xl" data-id="element-142" data-mp="3ho63y38zf9z4">
                6
              </p>
              <p className="mt-2 text-xs font-bold text-greenlive sm:text-sm" data-id="element-143" data-mp="3rfttfylzagxy">
                Tomos listos
              </p>
            </div>
            <div data-id="element-144" data-mp="3moll75wdx1md">
              <p className="text-2xl font-black leading-none text-white sm:text-3xl" data-id="element-145" data-mp="3mo2d0gwjdrlj">
                6
              </p>
              <p className="mt-2 text-xs font-bold text-greenlive sm:text-sm" data-id="element-146" data-mp="2yxg7awa08jep">
                Bonos incluidos
              </p>
            </div>
            <div data-id="element-147" data-mp="19hm5zsooxwfs">
              <p className="text-2xl font-black leading-none text-white sm:text-3xl" data-id="element-148" data-mp="19h2rkly91q6i">
                4.9/5
              </p>
              <p className="mt-2 text-xs font-bold text-greenlive sm:text-sm" data-id="element-149" data-mp="1eb6yj57ily7l">
                calificación ⭐
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}